module.exports = __webpack_public_path__ + "static/media/body-bg-5.823e9502.jpg";